import { createContext, useContext } from 'react'
import type { KenoBetType } from '@nexbit/types'
import type { TableState } from './api'

export type DisplayMode = 'normal' | 'simple' | 'trend'

/** What every table card needs from the page around it. */
export interface Board {
  displayMode: DisplayMode
  tier: { id: string; min: number; max: number }
  balance: number | null
  setBalance: (b: number) => void
  checkBalance: () => void
  lastStake: number | ''
  setLastStake: (n: number) => void
  /** Pending stake per round, per bet type — the amounts printed on the bet cells. */
  stakes: Record<string, Partial<Record<KenoBetType, number>>>
  addStake: (roundId: string, betType: KenoBetType, amount: number) => void
  /** Ask for fresh table state now (deduped); the newest is passed down as props. */
  refreshTables: () => void
  serverNow: () => number
  openWindow: (path: string) => void
  playWin: () => void
  playLoss: () => void
  fullscreen: (gameId: string) => void
  hiddenIds: Set<string>
  fullscreenId: string | null
}

export const BoardContext = createContext<Board | null>(null)

export function useBoard(): Board {
  const b = useContext(BoardContext)
  if (!b) throw new Error('useBoard outside BoardContext')
  return b
}

export type { TableState }
